import { BOAT_DIMENSIONS, COXSWAIN_DIMENSIONS, ROWER_DIMENSIONS, COLORS } from './constants';

interface CoxswainProps {
  x: number;
}

/**
 * Coxswain component - renders the coxswain (smaller than rowers, positioned lower in boat)
 * The coxswain sits in the stern behind the stroke seat
 */
export const Coxswain = ({ x }: CoxswainProps) => {
  const { HULL_HEIGHT_ABOVE_WATER } = BOAT_DIMENSIONS;
  const {
    TORSO_WIDTH,
    TORSO_DEPTH,
    TORSO_HEIGHT,
    HEAD_RADIUS,
    SEAT_HEIGHT,
    SEAT_SIZE,
    SEAT_Y_OFFSET,
  } = COXSWAIN_DIMENSIONS;
  const { HEAD_SEGMENTS_WIDTH, HEAD_SEGMENTS_HEIGHT } = ROWER_DIMENSIONS;

  const seatY = HULL_HEIGHT_ABOVE_WATER + SEAT_Y_OFFSET;

  return (
    <group position={[x, seatY, 0]}>
      {/* Coxswain seat (smaller) */}
      <mesh position={[0, 0, 0]} castShadow receiveShadow>
        <boxGeometry args={[SEAT_SIZE, SEAT_HEIGHT, SEAT_SIZE]} />
        <meshStandardMaterial color={COLORS.COX_SEAT} />
      </mesh>

      {/* Torso (smaller than rowers) */}
      <mesh position={[0, TORSO_HEIGHT / 2 + SEAT_HEIGHT, 0]} castShadow receiveShadow>
        <boxGeometry args={[TORSO_DEPTH, TORSO_HEIGHT, TORSO_WIDTH]} />
        <meshStandardMaterial color={COLORS.COX_UNIFORM} />
      </mesh>

      {/* Head (sphere on top of torso) */}
      <mesh position={[0, TORSO_HEIGHT + SEAT_HEIGHT + HEAD_RADIUS, 0]} castShadow receiveShadow>
        <sphereGeometry args={[HEAD_RADIUS, HEAD_SEGMENTS_WIDTH, HEAD_SEGMENTS_HEIGHT]} />
        <meshStandardMaterial color={COLORS.SKIN_TONE} />
      </mesh>
    </group>
  );
};
